import { styled, Paper } from '@mui/material';

export const StyledPaper = styled(Paper)({
  borderRadius: '20px',
  margin: '20px 0',
  padding: '40px',
});
